import Swiper, { Navigation, FreeMode } from 'swiper';
import Component from '../Component';

class ImgTextSlider extends Component {
  constructor(options) {
    super(options);
    this.next = this.root.querySelector('.swiper_next');
    this.prev = this.root.querySelector('.swiper_prev');
  }

  attachEventListeners() {
    new Swiper(this.root, {
      modules: [Navigation, FreeMode],
      slidesPerView: 'auto',
      loop: false,
      grabCursor: true,
      spaceBetween: 15,
      navigation: {
        nextEl: this.next,
        prevEl: this.prev
      },
      centeredSlides: true,
      breakpoints: {
        768: {
          freeMode: {
            enabled: true
          },
          centeredSlides: false
        }
      }
    });
  }

  componentDidMount() {
    this.attachEventListeners();
  }
}

export default ImgTextSlider;